/* global google */

/**
 * Initialize ACF Google Maps
 *
 * @param {Function} $ - jQuery
 */
(function ($) {
  /**
   * Renders a Google Map onto the selected jQuery element
   *
   * @param {jQuery} $el The jQuery element.
   * @return {Object}     The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    const $markers = $el.find('.marker');

    // Create generic map.
    const mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    const map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map, $el);

    // Return map instance.
    return map;
  }

  /**
   * Creates a marker for the given jQuery element and map.
   *
   * @param {jQuery} $marker The jQuery element.
   * @param {Object} map     The map instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    const lat = $marker.data('lat');
    const lng = $marker.data('lng');

    // Debug: log the values
    console.log('Marker data-lat:', lat, 'data-lng:', lng);
    console.log('Marker element:', $marker[0]);

    const latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    console.log('Parsed latLng:', latLng);

    // Check if coordinates are valid
    if (isNaN(latLng.lat) || isNaN(latLng.lng)) {
      console.error('Invalid coordinates for marker');
      return;
    }

    // Create marker instance.
    const marker = new google.maps.Marker({
      position: latLng,
      map,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      const infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * Centers the map showing all markers in view.
   *
   * @param {Object} map The map instance.
   * @param {jQuery} $el The map container element.
   */
  function centerMap(map, $el) {
    // Create map boundaries from all map markers.
    const bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    console.log('Centering map, markers count:', map.markers.length);
    console.log('Bounds center:', bounds.getCenter().toString());

    // Case: Single marker.
    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom($el.data('zoom') || 14);

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  /**
   * Initialize all maps
   */
  function initAllMaps() {
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
      // Wait for Google Maps to load
      setTimeout(initAllMaps, 100);
      return;
    }

    $('.acf-map').each(function () {
      initMap($(this));
    });
  }

  // Render maps on page load.
  $(document).ready(function () {
    initAllMaps();
  });
})(jQuery);
